import { render } from "./MainBanner.vue?vue&type=template&id=9a11388c&scoped=true&ts=true"
import script from "./MainBanner.vue?vue&type=script&lang=ts"
export * from "./MainBanner.vue?vue&type=script&lang=ts"

import "./MainBanner.vue?vue&type=style&index=0&id=9a11388c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a11388c"]])

export default __exports__